module.exports = __webpack_public_path__ + "media/assets/GreenCheckWithBg-27063e0bb767a6956b24fa3c22e6d868.svg";